import { number, object } from 'yup';

import he from '../../translations/he';
import { emptyValueCheck } from './customValidations';

const INVALID_ID_MESSAGE =
  he.configuration.shippingCompanyConfiguration.filters.invalidShippingCompanyId;

export const shippingCompaniesSearchValidation = object().shape({
  shippingCompanyId: number()
    .transform(emptyValueCheck)
    .nullable()
    .positive(INVALID_ID_MESSAGE)
    .integer(INVALID_ID_MESSAGE),
});
